<template>
  <div class="box">
    <div
      v-if="
        $store.state.role === 'school-role' ||
        $store.state.role === 'teacher-role' ||
        $store.state.role === 'audit-role' ||
        $store.state.role === 'education-guide-role' ||
        $store.state.role === 'education-role'
      "
    >
      <!-- 学校/教师/审核员/教育厅/教育局：卡片总览；tableView / auditTable 文件保留不删 -->
      <school-project-list module-type="studio" />
    </div>
    <div v-if="$store.state.role === 'expert-role'">
      <expert-table-view
        :pagination="pagination"
        :timestampStartTime="timestampStartTime"
        :timestampEndTime="timestampEndTime"
        :reviewStartTimestamp="reviewStartTimestamp"
        :reviewEndTimestamp="reviewEndTimestamp"
        :reviewStartTime="reviewStartTime"
        :reviewEndTime="reviewEndTime"
        :data="expertData"
        @updataInfo="updataInfo"
        @getApplyZjApplyList="getApplyZjApplyList"
        @reviewSubmit="reviewSubmit"
        type="szStudio"
        :wokrName="'工作室'"
        :applyCount="applyCount"
        :schoolCount="schoolCount"
      ></expert-table-view>
    </div>
    <!-- 教育厅/局（education-guide-role/education-role）已改用卡片总览 school-project-list，见上方 school-role 分支 -->
    <div v-if="$store.state.role === 'score-role'">
      <a-spin :spinning="spinning" tip="文件导出中,请稍等...">
        <education-table
          :dataList="dataList"
          :pagination="pagination"
          @getLxApplyjyjApplylist="getLxApplyjyjApplylist"
          @editInfo="editInfo"
          @lxApplyExportZip="lxApplyExportZip"
          :applyCount="applyCount"
          :schoolCount="schoolCount"
        />
      </a-spin>
    </div>
    <!-- <diff :obj1="oldData" :obj2="newData" :fieldLabels="fieldLabels"></diff>
    <diff :obj1="oldData1" :obj2="newData1" :fieldLabels="fieldLabels"></diff> -->
  </div>
</template>

<script>
import {
  lxApplyApplylist,
  lxApplyApplyDelete,
  applyDateView,
  expertDateView,
  lxApplyjApplylist,
  lxApplyZjApplyList,
  lxApplyExportZip,
  lxApplytApplylist,
} from "../../api/index";
import { getApplyOverviewList } from "../../api/auditTask.js";
import { getTsFormatDate } from "../../utils/time";
import tableView from "../../components/common/tableView.vue";
import expertTableView from "../../components/common/expertTableView.vue";
import educationTable from "../../components/common/educationTable.vue";
import auditTable from "../../components/common/auditTable.vue";
import diff from "../../components/common/diff.vue";
import SchoolProjectList from "../../components/projectShell/SchoolProjectList.vue";
export default {
  name: "",
  components: {
    tableView,
    expertTableView,
    educationTable,
    auditTable,
    SchoolProjectList,
  },
  props: {},
  data() {
    return {
      isShowView: false,
      dataList: [],
      loading: true,
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10, //每页中显示10条数据
      },
      startTime: "",
      endTime: "",
      // 评审时间
      reviewStartTime: "",
      reviewEndTime: "",
      btnShow: true,
      timestampStartTime: "",
      timestampEndTime: "",
      expertData: [], //专家表格内容
      // 评审时间戳
      reviewStartTimestamp: "",
      reviewEndTimestamp: "",
      applyCount: 0,
      schoolCount: 0,
      spinning: false,
      oldData: { name: "张三", age: "18", dec: "dlksjd" },
      newData: { name: "张三", age: "19", dec: "" },
      oldData1: { name: "张三", age: "18", dec: "dlksjd" },
      newData1: { name: "里斯", age: "18", dec: "" },
      fieldLabels: { name: "姓名", age: "年龄", dec: "描述" },
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    // 学校/教师/审核员列表改由 SchoolProjectList 自行拉取，此处不再请求
    if (
      this.$store.state.role === "score-role" ||
      this.$store.state.role === "education-role"
    ) {
      this.getLxApplyjyjApplylist({
        page: 1,
        size: 10,
      });
    }
    if (this.$store.state.role === "expert-role") {
      this.getApplyZjApplyList({
        page: 1,
        size: 10,
      });
      this.getexpertDateView();
    }
    // education-guide-role 列表已改由 SchoolProjectList 自行拉取，此处不再请求
  },
  methods: {
    updataInfo() {
      this.getApplyZjApplyList({
        page: 1,
        size: 10,
      });
    },
    // 学校列表
    getLxApplyApplylist(pagination) {
      this.loading = true;
      let data = {
        applyType: "",
        pageNo: pagination.page,
        pageSize: pagination.size,
      };
      if (pagination.realname != "") {
        data.schoolName = pagination.realname;
      }
      if (pagination.name != "") {
        data.name = pagination.name;
      }
      if (pagination.applyYear != "") {
        data.applyYear = pagination.applyYear;
      }
      if (pagination.auditState != "") {
        data.auditState = pagination.auditState;
      }
      if (this.$route.name === "szStudio") {
        data.applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        data.applyType = 2;
      } else {
        data.applyType = 3;
      }
      lxApplyApplylist(data).then((res) => {
        if (res.code === 0) {
          let data = res.result.records;
          if (data) {
            this.dataList = data;
            this.pagination.total = res.result.total;
          }
        }
        this.loading = false;
      });
    },
    // 教育局列表
    getLxApplyjyjApplylist(pagination) {
      this.loading = true;
      let data = {
        applyType: "",
        pageNo: pagination.page,
        pageSize: pagination.size,
        roleCode: "education",
      };
      if (pagination.realname != "") {
        data.schoolName = pagination.realname;
      }
      if (pagination.name != "") {
        data.name = pagination.name;
        data.keyword = pagination.name;
      }
      if (pagination.applyYear != "") {
        data.applyYear = pagination.applyYear;
      }
      if (pagination.auditState != "") {
        data.auditState = pagination.auditState;
      }
      if (this.$route.name === "szStudio") {
        data.applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        data.applyType = 2;
      } else {
        data.applyType = 3;
      }
      // 评分角色参数
      if (this.$store.state.role === "score-role") {
        data.auditState = 2;
      }
      // 教育厅/局统一走 getApplyOverviewList，后端按 roleCode=education 限制只看
      // 待教育局审核(1+level2)/审核通过(2)/教育局驳回(3+level2)
      getApplyOverviewList(data).then((res) => {
        if (res.code === 0 || res.code === 200) {
          let data = res.result.records;
          if (data) {
            this.dataList = data;
            this.pagination.total = res.result.total;
          }
        }
        this.loading = false;
      });
    },
    // 获取专家列表
    getApplyZjApplyList(pagination) {
      let data = {
        applyType: "",
        pageNo: pagination.page,
        pageSize: pagination.size,
      };
      if (pagination.realname != "") {
        data.schoolName = pagination.realname;
      }
      if (pagination.name != "") {
        data.name = pagination.name;
      }
      if (pagination.applyYear != "") {
        data.applyYear = pagination.applyYear;
      }
      if (pagination.auditState != "") {
        data.auditState = pagination.auditState;
      }
      if (this.$route.name === "szStudio") {
        data.applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        data.applyType = 2;
      } else {
        data.applyType = 3;
      }
      lxApplyZjApplyList(data).then((res) => {
        if (res.code === 200) {
          this.expertData = res.result.pageList.records;
          this.applyCount = res.result.applyCount;
          this.schoolCount = res.result.schoolCount;
          this.pagination.total = res.result.pageList.total;
        }
      });
    },
    deleteApply(id) {
      lxApplyApplyDelete({ id }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message);
          this.getLxApplyApplylist({
            page: 1,
            size: 10,
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    editInfo(params, type) {
      params.type = type;
      let applyType = 0;
      if (this.$route.name === "szStudio") {
        applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        applyType = 2;
      } else {
        applyType = 3;
      }
      let news = "edit";
      if (params.type) {
        news = params.type;
      }
      // console.log(params,type,"想要的");
      this.$router.push({
        name: `${this.$route.name}DataUpload`,
        query: { id: params.id, applyType: applyType, new: news },
      });
    },
    // 获取申报时间
    getapplyDateView() {
      applyDateView().then((res) => {
        if (res.code == 200) {
          this.timestampStartTime = res.result.startTime;
          this.timestampEndTime = res.result.endTime;
          var startTime = parseInt(res.result.startTime);
          var endTime = parseInt(res.result.endTime);
          this.startTime = getTsFormatDate(startTime);
          this.endTime = getTsFormatDate(endTime);
          var date1 = new Date();
          var timestamp = Date.parse(date1);
          if (timestamp < this.timestampStartTime) {
            this.btnShow = false;
          } else if (timestamp > this.timestampEndTime) {
            this.btnShow = false;
          } else if (
            timestamp > this.timestampStartTime &&
            timestamp < this.timestampEndTime
          ) {
            this.btnShow = true;
          }
        }
      });
    },
    // 获取评审时间
    getexpertDateView() {
      expertDateView().then((res) => {
        if (res.code == 200) {
          var startTime = parseInt(res.result.startTime);
          var endTime = parseInt(res.result.endTime);
          this.reviewStartTime = getTsFormatDate(startTime);
          this.reviewEndTime = getTsFormatDate(endTime);
          this.reviewStartTimestamp = res.result.startTime;
          this.reviewEndTimestamp = res.result.endTime;
        }
      });
    },
    goQuery(query) {
      const pagination = {
        page: 1,
        size: 10,
        name: query.name,
        principals: query.principals,
        schoolName: query.schoolName,
        Integrity: query.Integrity,
      };
      this.getApplyZjApplyList(pagination);
    },
    goQuerySchool(query) {
      const pagination = {
        page: 1,
        size: 10,
        name: query.name,
        principals: query.principals,
        Integrity: query.Integrity,
      };
      this.getLxApplyApplylist(pagination);
    },
    lxApplyExportZip(data) {
      // console.log(data);
      this.spinning = true;
      let params = {};
      if (this.$route.name === "szStudio") {
        params.applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        params.applyType = 2;
      } else {
        params.applyType = 3;
      }
      if (data.schoolName != "") {
        params.schoolName = data.schoolName;
      }
      if (data.workroomName != "") {
        params.name = data.workroomName;
      }
      if (data.projectPrincipal != "") {
        params.principals = data.projectPrincipal;
      }
      if (data.Integrity != "") {
        params.applyFilesFull = data.Integrity;
      }
      lxApplyExportZip(params).then((res) => {
        let url = window.URL.createObjectURL(
          new Blob([res], { type: "application/zip" })
        );
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        let fileName = "";
        if (this.$route.name === "szStudio") {
          fileName = "思政工作室";
        } else if (this.$route.name === "educationalBrand") {
          fileName = "特色文化育人品牌";
        } else {
          fileName = "思政微课";
        }
        link.setAttribute("download", `${fileName}遴选作品批量下载` + ".zip");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); //下载完成移除元素
        window.URL.revokeObjectURL(url); //释放掉blob对象
        this.spinning = false;
      });
    },
    // 评审提交回显
    reviewSubmit() {
      this.getApplyZjApplyList({
        page: 1,
        size: 10,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 100%;
  // max-height: 635px;
  overflow-y: auto;
  padding: 19px 16px;
  min-height: 450px;
}
</style>
